// Shared desktop/PWA proof submission. Recording a reference is not payment credit.
export function bindDepositProof(options: {
  input: HTMLInputElement | null;
  button: HTMLButtonElement | null;
  status: HTMLElement | null;
  depositId: () => string;
  isUPI: () => boolean;
  submit: (depositId: string, reference: string) => Promise<unknown>;
  refresh: () => Promise<void>;
}) {
  let submitting = false;
  let recorded = false;
  const message = (text: string, color: string) => {
    if (options.status) {
      options.status.textContent = text;
      options.status.style.color = color;
    }
  };
  const onClick = async () => {
    if (submitting || recorded) return;
    const reference = options.input?.value.trim() || '';
    const valid = options.isUPI() ? /^\d{12}$/.test(reference) : /^[A-Za-z0-9:_-]{12,128}$/.test(reference);
    if (!valid) {
      message(options.isUPI() ? 'Enter a 12-digit UPI UTR.' : 'Enter a valid transaction reference (12–128 characters).', '#f87171');
      return;
    }
    const depositId = options.depositId();
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(depositId)) {
      message('No valid deposit intent. Reopen the deposit form before submitting proof.', '#f87171');
      return;
    }
    submitting = true;
    if (options.button) options.button.disabled = true;
    if (options.input) options.input.disabled = true;
    message('Submitting proof for verification…', '#94a3b8');
    try {
      const res: any = await options.submit(depositId, reference);
      recorded = true;
      if (res && res.status === 'COMPLETED') {
        const bonusMsg = res.bonus_granted_cents > 0 ? ` (+${(res.bonus_granted_cents / 100).toFixed(2)} ${res.credited_currency || ''} bonus activated)` : '';
        message(`🎉 Deposit confirmed & credited! ${res.credited_amount ? `${res.credited_amount} ${res.credited_currency || ''}` : ''}${bonusMsg}`, '#34d399');
      } else {
        message('Reference recorded · awaiting payment verification. This is not confirmation of credit.', '#34d399');
      }
    } catch (error: unknown) {
      const detail = error instanceof Error ? error.message : 'Submission unavailable';
      message(`Could not confirm proof submission: ${detail}. Check status or retry the same reference.`, '#f87171');
    } finally {
      submitting = false;
      if (options.button) options.button.disabled = recorded;
      if (options.input) options.input.disabled = recorded;
    }
    if (recorded) {
      if (typeof BroadcastChannel !== 'undefined') {
        try {
          const bc = new BroadcastChannel('starx_rewards_sync');
          bc.postMessage({ type: 'BALANCE_UPDATED' });
          bc.close();
        } catch {}
      }
      try {
        await options.refresh();
      } catch {
        message('Reference recorded. Balance refresh unavailable; check deposit status later. Do not pay again.', '#f59e0b');
      }
    }
  };
  options.button?.addEventListener('click', onClick);
  return onClick;
}
